// extracted by mini-css-extract-plugin
module.exports = {"app-main":"App_app-main__ncV0g"};